module.exports = __webpack_public_path__ + "media/images/views/lp/home/features/talent-a289891443793684f34fbe9d8771c1d6.png";